module.exports = __webpack_public_path__ + "img/ic-arrow-down.4bef0f76.svg";